

export class userAddress{
    city :string;
    state :string;
}

export class hierarchyGroup{
    programName:string;
    jobRoleId:string;
}

export class uniqueFieldValidation{
    eMailId: string;
    gstNumber: string;
    panNumber: string;
    mobileNumber: string
    userName: string;
    programName: string
    isUserUpdate:boolean
    updateUserName:string;

    uniqueFieldValidation(){
        this.eMailId = '';
        this.gstNumber = '';
        this.panNumber = '';
        this.mobileNumber = '';
        this.programName = '';
        this.isUserUpdate = false;
        this.updateUserName = '';
    }
}

export class userApprovalSearchCriteria{   
    UserId:string;
    Status:string;
    UserName:string;
    CompanyName:string;
    PanNo:string;
    DateofRegistratio:string;
    GSTNumber:string;
    RTONo:string;
    MobileNumbe:string;
    PanNumber:string;
    State:string;
    OrganisationCode:string;
    DistributorCode:string;
    ProgramName:string;
    pageNumber: number;
    itemsPerPage: number;
    sortField: string;
    sortAscending: boolean;
    additionalData: object;

    constructor () {
        this.pageNumber = 1;
        this.itemsPerPage = 10;
        this.sortField = '';
        this.sortAscending = true;
    }
}